<template>
  <div class="app-logo leading-none select-none" :class="inverted ? 'text-black' : 'text-[#c8962a]'">
    <div class="ornament">
      <span class="line" />
      <span class="gem">✦</span>
      <span class="line" />
    </div>
    <div class="title">
      <div>ОСНОВИ</div>
      <div>ВІРИ</div>
    </div>
    <div class="ornament">
      <span class="line" />
      <span class="gem">✦</span>
      <span class="line" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ inverted?: boolean }>()
</script>

<style scoped>
.app-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.title {
  font-family: 'Cormorant Garamond', 'PT Serif', serif;
  font-weight: 700;
  font-size: 1.15rem;
  letter-spacing: 0.18em;
  text-align: center;
  line-height: 1.1;
  text-transform: uppercase;
}

.ornament {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.line {
  flex: 1;
  height: 1px;
  background-color: currentColor;
  opacity: 0.6;
}

.gem {
  font-size: 0.45rem;
  opacity: 0.8;
}
</style>
